$(document).ready(function(){
  // Grid View and List View on Collection page
  $(document).on('click','.collection_main_views .collection_view .sub_div',function(){
    $('.collection_view').removeClass('active');
    $(this).parent().addClass('active');
    var select_view = $(this).data('view');
    if(select_view == 'grid'){
      $('#main-collection-product-grid').removeClass('pro_list_view');
      $('#main-collection-product-grid').addClass('pro_grid_view');
    }else{
      $('#main-collection-product-grid').removeClass('pro_grid_view');
      $('#main-collection-product-grid').addClass('pro_list_view');
    }
  });

  // Load more on Collection page

    $(window).on('scroll', function() {
        var $button = $('.js-load-more');
        
        if ($button.is(':visible')) {
            var buttonTop = $button.offset().top;
            var windowBottom = $(window).scrollTop() + $(window).height();
            
            if (buttonTop <= windowBottom) {
                $button.trigger('click');
            }
        }
    });

    $(document).on('click', '.js-load-more' ,function() {
        var $this = $(this);
        loadMoreProducts($this);
    });
  
    function loadMoreProducts($this) {
    var	totalPages = parseInt($('[data-all-pages]').val());
    var	currentPage = parseInt($('[data-this-page]').val());
    var	datacollurl = $('[data-coll-url]').val();
    $this.attr('disabled', true);
    $this.html('<span load-more-text>Loading...</span>');
    setTimeout(function() {
        $this.addClass('loading_btn');
    }, 200);
    setTimeout(function() {
        //$this.find('[load-more-text]').addClass('hide');
        $this.find('[loader]').removeClass('hide');
        var nextUrl = $('[data-next-link]').val();
        var current_page_new = currentPage + 1;
        var next_coll = currentPage + 2; 
        $.ajax({
            url: nextUrl,
            type: 'GET',
            dataType: 'html',
            success: function(responseHTML) {
            var next_page_new = current_page_new + 1;
                if(nextUrl.indexOf('page=') != -1){
                    nextUrl = nextUrl.replace("page="+current_page_new, "page="+next_page_new);
                }else{
                if(nextUrl.indexOf('?') != -1){
                    nextUrl = nextUrl + "&page="+next_page_new;
                }else{
                    nextUrl = nextUrl + "?page="+next_page_new;
                }
                }
                console.log(nextUrl);
                $('[data-next-link]').val(nextUrl);
                $('[data-this-page]').val(current_page_new);
                $('#blog_list').append($(responseHTML).find('#blog_list').html());
                $('#main-collection-product-grid').append($(responseHTML).find('#main-collection-product-grid').html());
                setTimeout(function() {
                    $('#blog_list').find('.load-more_wrap').remove();
                }, 100);
            },
            complete: function() {
                if (current_page_new < totalPages) {
                    $this.removeClass('loading_btn');
                    $this.html('<span load-more-text>Load more</span>');
                    $this.attr('disabled', false);
                    $this.find('[load-more-text]').removeClass('hide');
                    $this.find('[loader]').addClass('hide');
                }
                if (current_page_new >= totalPages) { 
                    $this.find('[load-more-text]').parents('.load-more_wrap').hide();
                }
            }
        });
    }, 1000);
    }

  
});
